const defaultRender = (value) => (value ? value : '--');

const cellsColumn = [
    {
        title: 'Name',
        dataIndex: 'name',
        render: defaultRender,
    },
    {
        title: "File No.",
        dataIndex: "file_number",
        render: defaultRender,
    },
    {
        title: "Email",
        dataIndex: "email",
        render: defaultRender,
    },
    {
        title:'Amount',
        dataIndex: 'amount',
        render: defaultRender,
    },
    {
        title:'Transfer Amount',
        dataIndex: 'transfer_amount',
        render: defaultRender,
    },
    {
        title: 'Status',
        dataIndex: 'status',
        render: defaultRender,
    },
    {
        title: 'Created Date',
        dataIndex: 'created_at',
        render: defaultRender,
    },
    {
        title: 'Action',
        dataIndex: 'action',
    },
];

export default cellsColumn;